module.exports = __webpack_public_path__ + "assets/icon-vegetationHeight-no.36547b5b.svg";